import { type GridValidRowModel, type GridColDef, type GridSortItem } from '@mui/x-data-grid'
import { type DataObjectList } from '../../models/DataObject'

// export interface FiltersSort {
//   direction: 'asc' | 'desc'
//   field: string
//   model?: string
// }

export interface ApplyFiltersAndDispatchParams {
  pageSize?: number
  pageNumber?: number
  search?: string
  sort?: GridSortItem | Record<string, any>
}

export enum FieldType {
  LINK = 'Link',
  CHIP = 'Chip',
  MULTIPLE_LINK = 'MultipleLink',
  TEXT_LIST = 'TextList',
  OBJECT_LIST = 'ObjectList',
  TEXT = 'Text',
  DATE = 'Date',
  NUMBER = 'Number',
  LINKED_ENTITY = 'LinkedEntity'

}

export enum Actions {
  EDIT = 'EDIT',
  DELETE = 'DELETE',
  ARCHIVE = 'ARCHIVE',
  SURVEY_PREVIEW = 'SURVEY_PREVIEW',
  GO_LIVE = 'GO_LIVE'
}

export enum TableModalAction {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  DELETE = 'DELETE',
  ARCHIVE = 'ARCHIVE',
  ERROR = 'ERROR',
  SURVEY_PREVIEW = 'SURVEY_PREVIEW',
  GO_LIVE = 'GO_LIVE'
}

export interface CustomColumnDef extends GridValidRowModel {
  alwaysShow?: boolean
  shown?: boolean
}

export type Row = Record<string, any>
export type ActionOnChildren = React.ReactElement<{ handleCloseModal: () => void }> | JSX.Element

export interface INoDataComponentProps {
  title?: string
  subTitle?: string
  icon?: React.ReactNode
}

export interface CustomTableProps<RowType extends Row> {
  list?: DataObjectList<Row> | null | undefined
  columns?: CustomColumnDef[]
  rows?: RowType[]
  label?: string
  createActionTitle?: string
  createAction?: ActionOnChildren
  editAction?: ActionOnChildren
  hideEditColumn?: boolean
  deleteAction?: ActionOnChildren
  errorAction?: ActionOnChildren
  archiveAction?: ActionOnChildren
  topbarTitle?: string
  enableAllSelection?: boolean
  hideSelectedColumnCount?: boolean
  defaultSort?: GridSortItem[] | undefined
  featureName?: string
  extraColumnProps?: object | undefined
  onEditClick?: (row: Row) => void
  onPreviewClick?: (row: Row) => void
  onGoLiveClick?: (row: Row) => void
  onRowClick?: (row: Row) => void
  onCellClick?: (row: Row) => void
  customTopbarAction?: React.ReactNode
  overrides?: Record<string, (a: any) => JSX.Element>
  createButtonProps?: object | undefined
  onSearch?: (value: string) => void
  handlePageChange?: (page: number) => Promise<void> | void
  handleRowsPerPageChange?: (page: number) => Promise<void> | void
  loading?: boolean
  noDataComponentProps?: INoDataComponentProps
  onSortModelChange?: (sortModel: GridSortItem) => Promise<void> | void
  actionModalEntityDisplayField?: string
  createModalProps?: object | undefined
  editModalProps?: object | undefined
  deleteModalProps?: object | undefined
  errorModalProps?: object | undefined
  extraModalProps?: object | undefined
  archiveModalProps?: object | undefined
  exportCsv?: () => void
  params?: Record<string, any>
  setParams?: (params: Record<string, any>) => void
}
